const deviceConstants = {
    GET_DOC_REQUEST:'GETDOC_DOC_REQUEST',
    GET_DOC_SUCCESS:'GETDOC_DOC_SUCCESS',
    GET_DOC_FAILURE:'GETDOC_DOC_FAILURE',

    CLEAR: 'DOC_CLEAR',
}

export default deviceConstants